
import React, { Component } from 'react';
import $ from 'jquery';
import carrerImg from "../images/carrer.jpg"
import {db,database,courseRef} from '../firebase'
export default class Career extends Component {
  constructor(props) {
    super(props)
    this.state = {
      careerData:[], 
    }
  
}

  componentDidMount(){
    this.renderList();
    
   }
   async  renderList(){
  
    let dataList=[]
    await database.ref("Course").once('value',function(snapshot){
       snapshot.forEach(
        function(ChildSnapshot){
          dataList.push({key:ChildSnapshot.key,CourseName:ChildSnapshot.val().CourseName,
            imageUrl:ChildSnapshot.val().imageUrl
          
          } )      
        }
      )
    })
  this.setState({careerData:dataList})
  }
    render() {
       

    return (

      <section className="career-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="career-panel"> 
                <div className="career-head">
                  <h4>Career Tracks</h4>
                  <p>Career assistance service to fina a suitable opportunituy - Resume writing,  Interview Coaching</p>
                </div>
                <div className="career-body">
                {this.state.careerData.map((data, i) => {
                    
                    return (
                  <div className="career-box">
                    <a href={"/course-details/id="+data.key} className="career-box-a">
                      <img  src={data.imageUrl} alt="" className="career-img" />
                      <p className="career-box-text">{data.CourseName}</p>
                    </a>
                  </div>
                    )})}
                </div>
                <div className='view-all'>
                  <a href='/careerTracks' className='view-all-btn'>View all</a>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
      )
    }
}


// WEBPACK FOOTER //
// ./src/home/career.jsx